import { ComponentUserToTransferVO, FromProductUserVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (
  input: ComponentUserToTransferVO,
  chatUserId: string,
  filter?: string
): Promise<Map<string, FromProductUserVO[]>> => {
  const params = filter ? `?chatUserId=${chatUserId}&filter=${filter}` : `?chatUserId=${chatUserId}`
  return fetcher(`/api/transfer/users/grouped${params}`, 'POST', input)
}
